document.addEventListener('DOMContentLoaded', function() {
	const anchor = window.location.hash; // Get the anchor from URL

	let offset = 120

    if (anchor) {
        setTimeout(function () {
            const target = document.querySelector(anchor);
            if (target) {
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.pageYOffset - offset,
                    behavior: 'smooth'
                });
            }
        }, 300); // Delay to ensure layout is fully loaded
    }
})